import axios, { type AxiosInstance } from "axios";

type CreateApiClientParams = {
  baseURL: string;
  partner: string;
  getAccessToken: () => Promise<string | null>;
};

export const createApiClient = ({ baseURL, partner, getAccessToken }: CreateApiClientParams): AxiosInstance => {
  const client = axios.create({ baseURL });

  client.interceptors.request.use(async (config) => {
    const token = await getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const params = (config.params ?? {}) as Record<string, string | number | boolean | undefined>;
    config.params = { ...params, partner };

    return config;
  });

  return client;
};
